import getListViewState from "../selectors/getListViewState";

export default function getSelectedItemParts(): string[] {
    return getListViewState().expandedConversationViewState.selectedNodeIds;
}
